import React from 'react';
import WebView from 'react-native-webview'


const partnership = () => {
    return <WebView source={{ uri: 'https://rioben.org.br/parceiros.html' }} />;
}

export default partnership;